import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';
export const TestCarDetailImageStyle: MediaSetting[] = [
  {
    screen: Screen.XXXS,
    key: '3_2_568',
    width: 568,
    height: 379,
    ratio: 1.5,
  },
  {
    screen: Screen.XS,
    key: '3_2_768',
    width: 768,
    height: 512,
    ratio: 1.5,
  },
  {
    screen: Screen.SM,
    key: '3_2_1024',
    width: 1024,
    height: 683,
    ratio: 1.5,
  },
];

export const TestCarImageStyle: MediaSetting[] = [
  {
    screen: Screen.XXXS,
    key: '3_2_568',
    width: 568,
    height: 379,
    ratio: 1.5,
  },
];
